import { render, staticRenderFns } from "./developer-app-credentials.vue?vue&type=template&id=361fc7a2&scoped=true&"
import script from "./developer-app-credentials.vue?vue&type=script&lang=js&"
export * from "./developer-app-credentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361fc7a2",
  null
  
)

export default component.exports